import React from 'react';
import { ImageBgContainer } from './ImageBgContainer';
import { Content } from './Content';
import type { IOnBoardingItem } from './onboarding';

export const Slide = ({
  item,
}: {
  item: IOnBoardingItem;
  index: number;
  length: number;
}) => {
  return (
    <ImageBgContainer bg={item.background}>
      <Content item={item} />
    </ImageBgContainer>
  );
};
